// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"e686b147","739":"0446f1eb"}[chunkId] + ".chunk.js";
};